import { atom } from "jotai";
import { useAtomValue } from "jotai";
export function extractLocaleFromUbisoftURL(url) {
    var match = url.match(/\/([a-z]{2}-[a-z]{2})\//);
    if (match) {
        return match[1];
    }
    else {
        return null;
    }
}
function getUbisoftUrlLocale() {
    if (process.env.DEBUG_ROUTER_ENABLED === "true") {
        var params = new URLSearchParams(window.location.search);
        return params.get("locale");
    }
    else {
        return extractLocaleFromUbisoftURL(window.location.href);
    }
}
export function useUbisoftUrlLocale() {
    return useAtomValue(UrlLocale);
}
export var UrlLocale = atom(getUbisoftUrlLocale());
